module.exports = __webpack_public_path__ + "img/RUS.a9a8a19c.gif";